import React, { useEffect, useState } from 'react';
import { List, ListItem, useTheme } from '@mui/material';
import { CodeHistoryItem } from './CodeHistoryItem';
import { getHistory, migrateFromLocalStorage } from '../services/historyService';

const CodeHistory = ({ onHistoryItemClick }) => {
    const [history, setHistory] = useState([]);
    const theme = useTheme();

    useEffect(() => {
        const loadHistory = async () => {
            const historyData = await getHistory();
            setHistory(historyData);
        };

        // Initial load and migration
        const init = async () => {
            await migrateFromLocalStorage();
            await loadHistory();
        };
        init();

        // Listen for history updates
        const handleHistoryUpdate = () => {
            loadHistory();
        };

        window.addEventListener('historyUpdated', handleHistoryUpdate);

        return () => {
            window.removeEventListener('historyUpdated', handleHistoryUpdate);
        };
    }, []);

    return (
        <List
            sx={{
                maxHeight: '400px',
                overflowY: 'auto',
                overflowX: 'hidden',
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                    background: theme.palette.scrollbar.track,
                    borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: theme.palette.scrollbar.thumb,
                    borderRadius: '4px',
                    '&:hover': {
                        background: theme.palette.scrollbar.thumbHover,
                    },
                },
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                boxSizing: 'border-box',
            }}
        >
            {history.map((item, index) => (
                <ListItem
                    key={`${item.code}-${item.timestamp}`}
                    sx={{
                        p: 0,
                        borderRadius: 2,
                        overflow: 'visible',
                        border: 'none',
                        width: '100%',
                        display: 'block',
                    }}
                    disablePadding
                >
                    <CodeHistoryItem 
                        code={item} 
                        onHistoryItemClick={onHistoryItemClick}
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default CodeHistory; 